import { TourInsurancesDto } from '@/features/dashboard/tourInsurances/types/TourInsurancesDto.ts';
import { TourInsuranceAssignmentRequest } from '@/features/dashboard/tourInsurances/types/TourInsuranceAssignmentRequest.ts';
import { TourInsuranceFormData } from '@/features/dashboard/tourInsurances/schemas/tourInsuranceSchema.ts';

/**
 * Formularz konfiguracji edytuje **stan docelowy przypisań**: PUT dostaje pełną
 * listę, a backend archiwizuje wszystko, czego w niej nie ma, i przywraca
 * wszystko, co w niej jest. Dlatego formularz startuje wyłącznie od przypisań
 * żywych — wciągnięcie wycofanego przywróciłoby je pierwszym zapisem.
 *
 * Wycofane globalnie ubezpieczenie z żywym przypisaniem **zostaje**: backend
 * przepuszcza je w liście (odrzuca dopiero dopięcie na nowo), a pominięcie go
 * po cichu zdjęłoby je z wyjazdu.
 */
export const tourInsurancesMapper = {
  fromDtoToForm(dto: TourInsurancesDto): TourInsuranceFormData {
    return {
      required: dto.required,
      insuranceIds: dto.insurances
        .filter((assignment) => !assignment.archived)
        .map((assignment) => assignment.insurance.id)
        .filter((id): id is string => id !== null),
    };
  },

  fromFormToDto(form: TourInsuranceFormData): TourInsuranceAssignmentRequest {
    return {
      required: form.required,
      insuranceIds: form.insuranceIds,
    };
  },
};
